import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { storageService } from './lib/supabase/storage';

// Inicializar serviços do Supabase
const initServices = async () => {
  try {
    // Inicializar o armazenamento do Supabase
    await storageService.initStorage();
  } catch (error) {
    // Silenciando erros de inicialização
  }
};

// Inicializar serviços
initServices();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
